import {Layer, view} from '@sail/ui';

export const Overlay = ({
  name,
  children,
}: {
  name: string;
  children: React.ReactNode;
}) => {
  return (
    <Layer name={name}>
      <view.div
        css={{
          position: 'fixed',
          inset: 'space.0',
          backgroundColor: 'rgba(0, 0, 0, 0.80)',
          backdropFilter: 'blur(4px)',
          stack: 'y',
          alignX: 'center',
          alignY: 'center',
        }}
      />
      <view.div
        css={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          stack: 'y',
          alignX: 'center',
          alignY: 'center',
          gap: 'medium',
          width: '360px',
          color: 'white',
          textColor: 'white',
          textAlign: 'center',
        }}
      >
        {children}
      </view.div>
    </Layer>
  );
};
